import { Fragment } from 'react';

import Column from 'bloko/blocks/column';
import Gap from 'bloko/blocks/gap';

import useTrls from 'hooks/translation/useTrls';

import AgreementInfo from 'components/Admin/PayerDetail/AgreementInfo';
import EditPayer from 'components/Admin/PayerDetail/EditPayer';
import PayerAttributes from 'components/Admin/PayerDetail/PayerAttributes';
import TitlePage from 'components/Admin/TitlePage';

import 'components/Admin/PayerDetail/PayerDetail.less';

const PayerDetail = () => {
    const trl = useTrls();

    return (
        <Fragment>
            <TitlePage>{trl('admin.PayerDetail.title')}</TitlePage>
            <Gap top bottom>
                <div className="payer-detail-container">
                    <Column xs="4" s="8" m="12" l="16" container>
                        <Column xs="4" s="8" m="6" l="8">
                            <PayerAttributes />
                        </Column>
                        <Column xs="4" s="8" m="6" l="8">
                            <Gap xsTop sTop>
                                <AgreementInfo />
                            </Gap>
                            <Gap top>
                                <div className="payer-detail-container">
                                    <EditPayer />
                                </div>
                            </Gap>
                        </Column>
                    </Column>
                </div>
            </Gap>
        </Fragment>
    );
};

export default PayerDetail;
